import { AUTH_LOCAL_STORAGE_KEY } from '../../app/modules/auth';

const parseJwt = () => {
  const token: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY),
    base64Url = token?.split('.')[1],
    base64: string | undefined = base64Url?.replace(/-/g, '+').replace(/_/g, '/');
  if (base64) {
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }
};

const copyToClipboard = (str: string) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

const truncateMiddle = (str: string, front = 6, back = 4) => {
  if (!str || str.length <= front + back) return str;
  return `${str.slice(0, front)}...${str.slice(-back)}`;
};

const commaSeperateNumber = (num: number | string): string => {
  if (num === null || num === undefined || num === '') {
    return '-';
  }

  const numberValue = typeof num === 'string' ? parseFloat(num) : num;
  if (isNaN(numberValue)) {
    return '-';
  }

  let formattedNumberString: string;
  const numberString = numberValue.toString();
  const decimalPart = numberString.split('.')[1];

  if (decimalPart && decimalPart.length > 6) {
    formattedNumberString = numberValue.toFixed(6);
  } else {
    formattedNumberString = numberString;
  }

  const parts = formattedNumberString.split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const finalDecimalPart = parts.length > 1 ? `.${parts[1]}` : '';

  return integerPart + finalDecimalPart;
};
export { parseJwt, copyToClipboard, truncateMiddle, commaSeperateNumber };
